import { FormSelect, FormSelectProps } from '@britishcouncil/react-admin';
import { FieldPath, FieldValues, get, PathValue, useController } from 'react-hook-form';
import { RHFormFieldProps } from './types';

type TValue = string | number | boolean | (string | number | boolean)[] | null;

type RHFormSelectProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = RHFormFieldProps<FormSelectProps<TValue>, TFieldValues, TName> & {
  onChange?: (value: PathValue<TFieldValues, TName>) => void;
};

export const RHFormSelect = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  control,
  rules,
  shouldUnregister,
  defaultValue,
  onChange,
  ...props
}: RHFormSelectProps<TFieldValues, TName>) => {
  const { field, formState } = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
  });

  const handleOnChange = (value: PathValue<TFieldValues, TName>) => {
    field.onChange(value);
    onChange?.(value);
  };

  return (
    <FormSelect
      {...props}
      name={name}
      value={field.value}
      onChange={handleOnChange}
      onBlur={field.onBlur}
      touched
      error={get(formState.errors, name)?.message}
    />
  );
};
